var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserType } from "healthex-common/user.dtos";
import { observable } from "mobx";
import { GlobalAdminUserFormModelBase } from "./GlobalAdminUserFormModelBase";
export class GlobalAdminExternalResearcherOrganizationUserFormModel extends GlobalAdminUserFormModelBase {
    constructor(opts) {
        super(opts);
        this.userInput = {
            email: "",
            phone: "",
            firstName: "",
            lastName: "",
            title: "",
            permissions: [],
            avatarUrl: "",
            newAvatar: null,
        };
        this.organizationsManager = opts.container.organizationsManager;
    }
    updateUserInput(update) {
        this.userInput = { ...this.userInput, ...update };
    }
    async loadUser(organizationId, userId, reload) {
        if (reload) {
            await this.organizationsManager.waitForReloadOrganizationUsers(organizationId);
        }
        const user = await this.organizationsManager.loadUserByOrganizationAndId(organizationId, userId);
        if (!user)
            return;
        const { email, phone, firstName, lastName, title, permissions, avatarUrl } = user;
        this.userInput = {
            email,
            phone,
            firstName: firstName !== null && firstName !== void 0 ? firstName : "",
            lastName: lastName !== null && lastName !== void 0 ? lastName : "",
            title,
            permissions,
            avatarUrl,
            newAvatar: null,
        };
    }
    getCreateUserInput() {
        const { email, permissions } = this.userInput;
        return {
            type: UserType.EXTERNAL_RESEARCHER,
            email,
            permissions,
        };
    }
    async performCreate() {
        if (this.opts.mode === "initialUser") {
            throw new Error("performCreate() should never be called in initialUser mode");
        }
        const updatedUser = this.getCreateUserInput();
        const userId = await this.organizationsManager.inviteUser(this.opts.organizationId, updatedUser);
        return userId;
    }
    async forcePasswordReset() {
        if (this.opts.mode !== "detail")
            return;
        await this.organizationsManager.forcePasswordReset(this.opts.organizationId, this.opts.userId);
    }
}
__decorate([
    observable
], GlobalAdminExternalResearcherOrganizationUserFormModel.prototype, "userInput", void 0);
